// extracted by mini-css-extract-plugin
export default {"wrapper":"FileInput_wrapper__3gfhp","label":"FileInput_label__nOBR8","input":"FileInput_input__7ejPM","fileWrapper":"FileInput_fileWrapper__JxfLs","error":"FileInput_error__0mgNp"};